/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useState } from 'react'
import extractMonthYearInRange from '../../../../CommonMethods/extractMonthYearInRange';

export default function MonthFilter({
    setSearchParams,
    searchParams, setIsMonthFilter }) {
    const [monthDorpDown, setMonthDropDown] = useState([]);
    
    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to calculate and set the month dropdown options based on the
    `start_date` and `end_date` values from the `searchParams` object. */
    useEffect(() => {
        const array = extractMonthYearInRange(searchParams.get("start_date"), searchParams.get("end_date"))
        setMonthDropDown(array)
    },[])
    /**
     * The function `handleSelectFilter` takes a month abbreviation as input, extracts the year from
     * it, updates the search parameters with the selected month and year, and sets the page number,
     * limit, and filter values.
     */
    const monthAbbreviationsToNumbers = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
        Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };
      
    const getMonthInfo = (monthAbbreviation) => {
        const [abbreviation, year] = monthAbbreviation.split(' ');
      
        const monthNumber = monthAbbreviationsToNumbers[abbreviation];
        if (monthNumber === undefined) {
            throw new Error('Invalid month abbreviation');
        }
      
        const date = new Date(year, monthNumber, 1);
        const fullMonthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
      
        return { monthNumber, fullMonthName };
    };
      
    const handleSelectFilter = (monthAbbreviation) => {
        try {
            const params = Object.fromEntries(searchParams);
            const { monthNumber, fullMonthName } = getMonthInfo(monthAbbreviation);
            const year = monthAbbreviation.split(' ')[1];
      
            setSearchParams({
                ...params,
                month: fullMonthName,
                year: year,
                page_number: 1,
                limit: 10,
                filter: true
            });
            setIsMonthFilter(false);
        } catch (error) {
            console.error('Error:', error);
        }
    };
      
    return (
        <ul className="slct_drp_dwn min-w-full [&amp;[data-te-dropdown-show]]:block" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref="" style={{'margin-left':'7px'}}>
            <li className="max-h-[150px] overflow-auto scroll-bar">
                <ul>
                    {monthDorpDown?.map((item) => (
                        <li key={item}>
                            <p
                                onClick={() => {handleSelectFilter(item)}}
                                className="slct_drp_dwn_optn selected_Class" 
                            >
                                {item}
                            </p>
                        </li>))}
                </ul>
            </li>
        </ul>
    )
}
